<bom-spinner message="Henter sag..."></bom-spinner>
